import React from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { useUser } from '~/providers/user';
import DocumentGridView from '~/routes/document_grid_view';
import DocumentsView from './documents_view';
import GridView from './grid_view';
import { ComparisonProvider } from './provider';
const Comparison = () => {
    const { useNewView } = useUser();
    const { id: comparisonId } = useParams();
    if (useNewView) {
        return React.createElement(ComparisonProvider, null,
            React.createElement("div", { className: 'comparison-page-container' },
                React.createElement(Routes, null,
                    React.createElement(Route, { path: 'compare/:id', element: React.createElement(Navigate, { to: `/compare/${comparisonId}/grid`, replace: true }) }),
                    React.createElement(Route, { path: '/documents', element: React.createElement(DocumentsView, null) }),
                    React.createElement(Route, { path: '/grid', element: React.createElement(GridView, null) }))));
    }
    return React.createElement("div", { className: 'old-comparison-page-container' },
        React.createElement(DocumentGridView, null));
};
export default Comparison;
